import { useSettings } from '@/hooks/useProducts';
import { useCartStore } from '@/stores/cart-store';
import { formatCurrency } from '@/lib/utils';
import { Truck } from 'lucide-react';

export default function FreeShippingBar() {
  const { data } = useSettings();
  const cartTotal = useCartStore((s) => s.total());

  const upsellConfig = data?.settings?.upsell_config;
  const config = upsellConfig?.free_shipping_bar;
  const threshold = Number(data?.settings?.free_shipping_threshold) || 50;

  if (!config?.enabled) return null;

  const remaining = Math.max(0, threshold - cartTotal);
  const progress = Math.min(100, (cartTotal / threshold) * 100);
  const unlocked = remaining <= 0;

  return (
    <div className="rounded-lg border border-line bg-surface p-4">
      <div className="flex items-center gap-2 text-sm mb-2">
        <Truck className="h-4 w-4 text-success-600 shrink-0" aria-hidden="true" />
        <span className={unlocked ? 'font-semibold text-success-700' : 'text-ink-soft'}>
          {unlocked
            ? (config.success_message || "You've unlocked FREE shipping!")
            : `You're ${formatCurrency(remaining)} away from FREE shipping!`
          }
        </span>
      </div>
      <div className="h-2 rounded-full bg-surface-muted overflow-hidden">
        <div
          className="h-full rounded-full transition-all duration-500 ease-out"
          style={{
            width: `${progress}%`,
            backgroundColor: config.bar_color || '#166534',
          }}
          role="progressbar"
          aria-valuenow={progress}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-label={`${Math.round(progress)}% to free shipping`}
        />
      </div>
    </div>
  );
}
